import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle, Phone, MessageCircle } from 'lucide-react';
import { advisorInfo } from '../data/mock';

const QASection = () => {
  const qaSections = [
    {
      id: "documents",
      question: "1) Dokumen Apa Diperlukan?",
      emoji: "📑",
      content: (
        <div className="space-y-6">
          <div className="bg-blue-50 rounded-xl p-6">
            <h4 className="font-bold text-blue-900 mb-4 flex items-center">
              <span className="text-xl mr-2">📑</span>
              Dokumen Wajib Untuk Submit Loan
            </h4>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white rounded-lg p-4 border border-blue-200">
                <h5 className="font-bold text-green-700 mb-3 flex items-center">
                  <span className="text-lg mr-2">✨</span>
                  Bekerja (tanpa OT/komisen):
                </h5>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center space-x-2">
                    <span>1️⃣ 🪪</span>
                    <span>IC (depan & belakang)</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>2️⃣ 🚘</span>
                    <span>Lesen Memandu (depan & belakang)</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>3️⃣ 📄</span>
                    <span>Slip Gaji 3 Bulan Terkini</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>4️⃣ 🏦</span>
                    <span>Bank Statement 3 Bulan Terkini</span>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 border border-blue-200">
                <h5 className="font-bold text-purple-700 mb-3 flex items-center">
                  <span className="text-lg mr-2">✨</span>
                  Bekerja dengan OT / Komisen:
                </h5>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center space-x-2">
                    <span>1️⃣ 🪪</span>
                    <span>IC (depan & belakang)</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>2️⃣ 🚘</span>
                    <span>Lesen Memandu (depan & belakang)</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>3️⃣ 📄</span>
                    <span>Slip Gaji 6 Bulan Terkini</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span>4️⃣ 🏦</span>
                    <span>Bank Statement 6 Bulan Terkini</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800">
                <strong>💡 Nota:</strong> Bank perlukan 6 bulan slip & statement untuk kira purata pendapatan (termasuk OT/komisen) → lebih mudah lulus ✅
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "student",
      question: "2) Student & Fresh Graduate Boleh ke?",
      emoji: "🎓",
      content: (
        <div className="space-y-4">
          <div className="bg-green-50 rounded-xl p-6">
            <h4 className="font-bold text-green-900 mb-4 flex items-center">
              <span className="text-xl mr-2">✨</span>
              Skim Graduan / Graduate Scheme
            </h4>
            <p className="text-green-800 mb-4">
              Ditawarkan oleh Maybank & Affin Bank untuk lepasan Diploma/Ijazah berumur 22 – 30 tahun 🎓
            </p>

            <div className="bg-white rounded-lg p-4 border border-green-200 mb-4">
              <h5 className="font-bold text-slate-800 mb-3">Syarat:</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Ada pengalaman kerja (walaupun sehari) 💼</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Jawatan Tetap / Permanent ✅</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Gaji minimum RM2,000 (pokok) & gaji bersih RM2,300 💰</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Ada lesen kereta sah (P/Full) 🚗</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-4 border border-green-200">
              <h5 className="font-bold text-slate-800 mb-3">📑 Dokumen Diperlukan:</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>IC (depan & belakang) 🆔</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Lesen Memandu (depan & belakang) 📝</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Transkrip / Sijil 🎓</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Surat Tawaran Kerja / Offer Letter 📬</span>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>👉 Nota tambahan:</strong> Student masih boleh apply loan, tapi wajib ada geranto (biasanya ibu bapa).
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "license",
      question: "3) Tiada Lesen Boleh Apply?",
      emoji: "🚫",
      content: (
        <div className="space-y-4">
          <div className="bg-orange-50 rounded-xl p-6">
            <h4 className="font-bold text-orange-900 mb-4">
              🚫 Tak ada lesen pun masih boleh apply loan!
            </h4>
            <p className="text-orange-800 mb-4">
              Cuma bank perlukan rujukan lesen memandu dalam keluarga.
            </p>

            <div className="bg-white rounded-lg p-4 border border-orange-200 mb-4">
              <h5 className="font-bold text-slate-800 mb-3">👨‍👩‍👧‍👦 Siapa boleh bagi lesen untuk rujukan?</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>✅</span>
                  <span>Pasangan (suami / isteri)</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>✅</span>
                  <span>Adik-beradik</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>✅</span>
                  <span>Ibu atau bapa</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-4 border border-orange-200 mb-4">
              <h5 className="font-bold text-slate-800 mb-3">📑 Dokumen diperlukan:</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Gambar pemilik lesen</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Lesen Memandu (depan & belakang)</span>
                </div>
              </div>
            </div>

            <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-sm text-green-800">
                <strong>💡 Nota:</strong> Ini bukan guarantor, hanya untuk rujukan bank sahaja ✅
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "new-job",
      question: "4) Baru Kerja Sebulan Boleh ke?",
      emoji: "💼",
      content: (
        <div className="space-y-4">
          <div className="bg-blue-50 rounded-xl p-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-2 text-green-700">
                <span>✅</span>
                <span className="font-semibold">Boleh, tapi wajib ada Offer Letter rasmi & status pekerja tetap.</span>
              </div>
              <div className="flex items-center space-x-2 text-red-700">
                <span>❌</span>
                <span className="font-semibold">Jika masih probation tanpa offer letter → kena ada penjamin (guarantor).</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "ctos",
      question: "5) Nama Ada CTOS / CCRIS Boleh ke?",
      emoji: "⚠️",
      content: (
        <div className="space-y-4">
          <div className="bg-red-50 rounded-xl p-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-2 text-red-700">
                <span>⚠️</span>
                <span className="font-semibold">CTOS tinggi memang susah lulus loan.</span>
              </div>
              <div className="flex items-center space-x-2 text-green-700">
                <span>✅</span>
                <span className="font-semibold">Tapi ada beberapa bank sahaja yang masih boleh terima permohonan.</span>
              </div>
              <div className="flex items-center space-x-2 text-blue-700">
                <span>👉</span>
                <span className="font-semibold">Peluang lulus bergantung pada skor & rekod kewangan.</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "housewife",
      question: "6) Suri Rumah Boleh Apply?",
      emoji: "👩‍🏠",
      content: (
        <div className="space-y-4">
          <div className="bg-pink-50 rounded-xl p-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-2 text-green-700">
                <span>✅</span>
                <span className="font-semibold">Boleh apply loan kereta.</span>
              </div>
              <div className="flex items-center space-x-2 text-blue-700">
                <span>📌</span>
                <span className="font-semibold">Syarat: Wajib ada suami sebagai geranto.</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "trade-in",
      question: "7) Boleh Trade-In Kereta Lama?",
      emoji: "🔄",
      content: (
        <div className="space-y-4">
          <div className="bg-purple-50 rounded-xl p-6">
            <div className="flex items-center space-x-2 text-green-700 mb-4">
              <span>✅</span>
              <span className="font-semibold">Ya, semua cawangan Perodua terima trade-in.</span>
            </div>

            <div className="bg-white rounded-lg p-4 border border-purple-200">
              <h5 className="font-bold text-slate-800 mb-3">📑 Dokumen trade-in:</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Geran Asal</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Salinan IC pemilik</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span>Settlement Letter (jika masih ada baki loan)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "process-time",
      question: "8) Berapa Lama Proses Loan Ambil Masa?",
      emoji: "⏱️",
      content: (
        <div className="space-y-4">
          <div className="bg-yellow-50 rounded-xl p-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-2 text-orange-700">
                <span>⏱️</span>
                <span className="font-semibold">Biasanya 3 – 5 hari bekerja untuk kelulusan bank.</span>
              </div>
              <div className="flex items-center space-x-2 text-green-700">
                <span>🚗</span>
                <span className="font-semibold">Jika semua dokumen lengkap & clear → kereta boleh terus register & siap lebih cepat.</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: "deposit",
      question: "9) Berapa Deposit Minimum?",
      emoji: "💰",
      content: (
        <div className="space-y-4">
          <div className="bg-green-50 rounded-xl p-6">
            <div className="flex items-center space-x-2 text-green-700 mb-4">
              <span>💰</span>
              <span className="font-semibold">Deposit minimum RM100 booking sahaja.</span>
            </div>

            <div className="bg-white rounded-lg p-4 border border-green-200">
              <h5 className="font-bold text-slate-800 mb-3">📌 Selebihnya ikut pilihan pelanggan:</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span><strong>Full Loan (0% deposit)</strong> → gaji kena cukup syarat.</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span>•</span>
                  <span><strong>10% Deposit</strong> → lebih mudah lulus & ansuran lebih rendah.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <section id="qa" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-blue-100 text-blue-800 text-sm font-medium px-4 py-2 rounded-full mb-4">
            <HelpCircle className="w-4 h-4 mr-2" />
            Q&A Section
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Q&A Pembelian
            <span className="text-blue-600"> Kereta Perodua</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Jawapan kepada soalan yang kerap ditanya tentang proses pembelian kereta Perodua
          </p>
        </div>

        {/* Q&A Content */}
        <Card className="bg-white shadow-2xl rounded-2xl border-0 overflow-hidden mb-12">
          <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-8">
            <CardTitle className="text-2xl font-bold text-center">
              Panduan Lengkap Pembelian Kereta Perodua
            </CardTitle>
            <p className="text-blue-100 text-center mt-2">
              Semua yang anda perlu tahu untuk proses yang lancar
            </p>
          </CardHeader>
          
          <CardContent className="p-8">
            <Accordion type="single" collapsible className="space-y-4">
              {qaSections.map((qa) => (
                <AccordionItem key={qa.id} value={qa.id} className="border border-slate-200 rounded-lg">
                  <AccordionTrigger className="px-6 py-4 hover:bg-slate-50 rounded-lg text-left font-semibold text-slate-800">
                    <div className="flex items-center space-x-3">
                      <span className="text-2xl">{qa.emoji}</span>
                      <span>{qa.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-2">
                    {qa.content}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>

        {/* Still Have Questions CTA */}
        <div className="text-center">
          <Card className="bg-gradient-to-r from-green-600 to-green-700 text-white shadow-2xl rounded-2xl border-0 p-8">
            <div className="max-w-2xl mx-auto">
              <div className="text-5xl mb-4">🤔</div>
              <h3 className="text-2xl font-bold mb-4">
                Masih Ada Soalan Lain?
              </h3>
              <p className="text-green-100 mb-6">
                Jangan segan untuk hubungi Syasyah terus untuk mendapatkan jawapan yang lebih terperinci
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent('[Website] PM PERODUA - Hi Syasyah, saya ada soalan tentang pembelian kereta Perodua. Boleh bantu saya?')}`, '_blank')}
                  className="bg-white text-green-600 hover:bg-green-50 font-bold px-8 py-3 rounded-xl text-lg transition-all duration-300 transform hover:scale-105"
                >
                  <MessageCircle className="w-5 h-5 mr-3" />
                  WhatsApp Syasyah
                </Button>
                <Button 
                  onClick={() => window.open(`tel:${advisorInfo.phone}`, '_blank')}
                  variant="outline"
                  className="border-2 border-white text-white hover:bg-white hover:text-green-600 font-bold px-8 py-3 rounded-xl text-lg transition-all duration-300"
                >
                  <Phone className="w-5 h-5 mr-3" />
                  Call {advisorInfo.phone}
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default QASection;